
// AdminEmployees.jsx
import React, { useState } from 'react';
import { Users, UserPlus } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import CompanyConfiguration from './company-configuration/CompanyConfiguration';
import useUrlTab from "modules/swiftboard/components/useUrlTab";
const Companies = () => {
  const [activeTab, setActiveTab] = useUrlTab(["company-configuration"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));

  const Tabs = [
    {
      id: 1,
      label: 'Company Configuration',
      icon: <Users size={18} />,
    },
    // {
    //   id: 2,
    //   label: 'Company Other Setting',
    //   icon: <UserPlus size={18} />,
    // }
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));


  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  };
 

  return (
    <TabPageLayout
      tabs={Tabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <CompanyConfiguration onTotalCountChange={setTabCount(1)} />}
      {/* {activeTab === 1 && <  />} */}
    </TabPageLayout>
  );
};

export default Companies;